const capitalize = (s: string) => s.length === 0
  ? s
  : s .length === 1
    ?s .charAt(0).toUpperCase()
    : `${s.charAt(0).toUpperCase()}${s.slice(1)}`;

export default capitalize;